import PropTypes from "prop-types";
import React from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

const CheckboxField = props => {
  const { input, containerClassName, meta, ...rest } = props;
  delete rest.meta;
  delete rest.input;
  delete rest.containerClassName;
  delete rest.error;
  delete rest.errorText;

  const inError = meta.touched && meta.invalid;
  return (
    <div>
      <FormControlLabel
        className={containerClassName}
        control={
          <Checkbox
            {...rest}
            checked={!!input.value}
            onChange={(e) => input.onChange(e.target.checked)}
          />
        }
        label={rest.label}
      />
      <div className="validation-error" style={{marginLeft: "7%"}}>
          {
            inError &&
            meta.error
          }
      </div>      
    </div>
    );
};

CheckboxField.propTypes = {
  input: PropTypes.object.isRequired,
  containerClassName: PropTypes.string,
  meta: PropTypes.object.isRequired,
};
export default CheckboxField;